import React, { useEffect, useState } from "react";
import { IoMdStarOutline } from "react-icons/io";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";
import CommonCTA from "../components/CommonCTA";

const TestimonialsPage = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // ✅ FETCH FROM API
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await api({
          url: SummaryApi.getAllTestimonials.url,
          method: SummaryApi.getAllTestimonials.method,
        });

        // ✅ only published
        const published = res?.data?.data?.filter(
          (t) => t.status === "Publish"
        );

        setTestimonials(published || []);
      } catch (error) {
        console.log(error);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <div className="w-full">

      {/* ================= HEADER ================= */}
      <section className="py-20 px-4 text-center">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-times text-[#2F2F2F] mb-4">
            Client Testimonials
          </h1>
          <p className="text-[#2F2F2FCC] text-sm md:text-base max-w-2xl mx-auto">
            Over the years, KL Property has helped many clients purchase genuine
            agricultural lands, plantation properties, and investment lands
            across Idukki, Thekkady, and Kumily.
          </p>
        </div>
      </section>

      {/* ================= TESTIMONIAL CARDS ================= */}
    <section className="px-4 pb-20">
      <div className="max-w-6xl mx-auto grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

        {testimonials.length === 0 ? (
          <div className="col-span-full text-center text-[#2F2F2F] py-10">
            No testimonials available
          </div>
        ) : (
          testimonials.map((item, index) => (
            <div
              key={item._id}
              onClick={() => setSelectedIndex(index)}
              className={`cursor-pointer bg-white p-6 rounded-xl transition
              ${
                selectedIndex === index
                  ? "ring-1 ring-[#45A301] shadow-md "
                  : "shadow-[0_2px_10px_rgba(0,0,0,0.04)] hover:shadow-md hover:ring-[#45A301] hover:ring-1"
              }`}
            >
              {/* ⭐ STARS */}
              <div className="flex text-[#45A301] mb-3">
                {[...Array(item.rating || 5)].map((_, i) => (
                  <IoMdStarOutline key={i} className="md:w-6 md:h-6" />
                ))}
              </div>

              {/* REVIEW */}
              <p className="text-[#2F2F2FE5] text-sm leading-relaxed mb-6">
                "{item.review}"
              </p>

              {/* USER */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-300">
                  {item.photo?.url ? (
                    <img
                      src={item.photo.url}
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-xs">
                      {item.name?.charAt(0)?.toUpperCase() || "U"}
                    </div>
                  )}
                </div>

                <div>
                  <p className="text-sm font-semibold text-[#2F2F2F]">
                    {item.name}
                  </p>
                  <p className="text-xs text-medium text-[#45A301]">
                    {item.location}
                  </p>
                </div>
              </div>
            </div>
          ))
        )}

      </div>
    </section>

      {/* ================= VIDEO SECTION ================= */}
    {testimonials?.[selectedIndex]?.clientExperience?.length > 0 && (
      <section className="bg-white py-16 px-4">
        <div className="max-w-6xl mx-auto">

          <h2 className="text-2xl font-serif text-[#2F2F2F] mb-2">
            Client Experiences
          </h2>
          <p className="text-[#6B7280] text-sm mb-10">
            Real moments from our happy clients.
          </p>

          {/* 🖼️ IMAGES */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {testimonials[selectedIndex].clientExperience.map((img, i) => (
              <div
                key={i}
                className="rounded-xl overflow-hidden shadow-sm"
              >
                <img
                  src={img.url}
                  alt="experience"
                  className="w-full h-[140px] md:h-[200px] object-cover"
                />
              </div>
            ))}
          </div>

        </div>
      </section>
    )}

    {/* ================= CTA ================= */}
    <CommonCTA />

    </div>
  );
};

export default TestimonialsPage;